import { BroadcastChannelTypeEnum } from 'app/models';

export class BroadcastChannelTypeModel {
    public static BroadcastChannelTypeList: Array<any> = [
        { name: 'SMS', value: BroadcastChannelTypeEnum.SMS },
        { name: 'Push Notification', value: BroadcastChannelTypeEnum.PushNotification },
        { name: 'Email', value: BroadcastChannelTypeEnum.Email },
        { name: 'In-App Notification', value: BroadcastChannelTypeEnum.InAppNotification }
    ];
}
